import React, { useEffect, useState } from "react";
import {
  listSavedProducts,
  removeSavedProduct
} from "../../api/buyerSaved.api";

import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";

const BuyerSavedProducts = () => {

  const navigate = useNavigate();

  const [data, setData] = useState([]);

  const fetchData = () => {

    listSavedProducts().then(res =>
      setData(res.data.data || [])
    );

  };

  useEffect(() => {

    fetchData();

  }, []);

  const handleDelete = async (id) => {

    await removeSavedProduct(id);

    fetchData();

  };

  const columns = [

    {
      name: "Product Name",
      grow: 2,
      cell: r => (
        <span
          onClick={() =>
            navigate(`/product/${r.listed_product_id}`)
          }
          style={{
            fontWeight: "700",
            color: "#112347",
            cursor: "pointer",
            textDecoration: "underline"
          }}
        >
          {r.product_name}
        </span>
      )
    },

    {
      name: "Seller",
      selector: r => r.business_name
    },

    {
      name: "Actions",
      right: true,
      cell: (row) => (

        <button
          className="btn btn-link text-danger fw-bold p-0 text-decoration-none text-nowrap"
          onClick={() => handleDelete(row.id)}
        >
          Remove Item
        </button>

      )
    }

  ];

  return (

    <div
      style={{
        backgroundColor: "#ffffff",
        padding: "clamp(15px, 3vw, 24px)",
        borderRadius: "12px",
        border: "1px solid #e5e7eb"
      }}
    >

      <h5
        className="fw-bold mb-4"
        style={{ color: "#112347" }}
      >
        Your Saved Products
      </h5>

      <div className="table-responsive border rounded-3 overflow-hidden">

        <DataTable
          columns={columns}
          data={data}
          pagination
        />

      </div>

    </div>

  );

};

export default BuyerSavedProducts;